export default __webpack_public_path__ + "static/media/AboutBrief-03.64ae1d68.png";